import { render, staticRenderFns } from "./addVoiceDialog.vue?vue&type=template&id=027d1d84"
import script from "./addVoiceDialog.vue?vue&type=script&lang=js"
export * from "./addVoiceDialog.vue?vue&type=script&lang=js"
import style0 from "./addVoiceDialog.vue?vue&type=style&index=0&id=027d1d84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports